import { css } from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

// styles for all input form elements
export const baseStyleOfFormElement = css<{ $smaller?: boolean, $invalid?: boolean }>`
    box-sizing: border-box;

    background-color: ${COLORS.BgMain};
    border: 2px solid ${COLORS.BgSecondary};
    color: ${COLORS.TextPrimary};

    border-radius: ${BorderRadius.componentRadius};

    padding: ${({ $smaller = false }) => $smaller ? '8px' : '14px'} 16px;
    transition: border 0.2s ease-in;

    &:hover,
    &:focus,
    &:active {
        outline: none !important;
        border-color: ${COLORS.GRAY_DARK};
    }

    ${({ $invalid = false }) => $invalid
        ? `
            &:invalid {
                border-color: ${COLORS.Error};
            }`
        : ''};
    
    &:disabled {
        border-color: ${COLORS.BgSecondary};
        background-color: ${COLORS.BgSecondary};
    }

    &::placeholder {
        color: ${COLORS.TextDisabled};
    }

    ${FONTS.XS};
`;
